import { useFormikContext } from "formik";
import { useState } from "react";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import BasicDateInput from "components/BasicInputs/BasicDateInput";
import ContainedTabs from "components/Tabs/Tabs3";
import HashtagIcon from "assets/icons/Hashtag";
import { DateObject } from "react-multi-date-picker";
import useResponsive from "helpers/useResponsive";

export default function AccountingCode() {
  const [disabled, setDisabled] = useState(true);
  const [value, setValue] = useState<string | number>();
  const data = useFormikContext<MaterialOrderData>();
  const { isMobile } = useResponsive();

  return (
    <div className={`flex items-center justify-between ${isMobile && "flex-col"}`}>
      <div className="flex items-center gap-4 p-4">
        <BasicTextInput
          disabled={disabled}
          style={{ padding: "0px 0px 0px 12px" }}
          suffix={
            <div
              className={`flex items-center justify-center gap-2 p-2 border-l border-dashed ${
                disabled ? "text-slate-300" : " text-slate-500"
              }`}
            >
              <HashtagIcon color={disabled ? "#b0bec5" : "#607d8b"} style={{ transform: "scale(0.9)" }} />
              <span>کد</span>
            </div>
          }
          val={data.values.accountingCode}
          onChange={(val) => {
            setValue(val);
            data.setFieldValue("accountingCode", val);
          }}
        />
        <ContainedTabs
          tabs={[
            { label: "اتوماتیک", activeColor: "#1062D0" },
            { label: "دستی", activeColor: "#CB0B0B" },
          ]}
          onChange={(val) => {
            data.setFieldValue("accountingCode", val === 0 ? undefined : value);
            setDisabled(val === 0);
          }}
          size={2}
          minWidth={70}
        />
      </div>

      <div className="">
        <BasicDateInput
          onChange={(dates) => {
            if (dates === undefined) return;
            data.setFieldValue("date", dates[0]);
          }}
          defaultValues={[data.values.date]}
          customView={(values: DateObject[]) => {
            if (!values || !values[0]) return;
            const date = values[0];
            return (
              <div className="flex flex-row-reverse items-center gap-2 text-base text-dark-3">
                <span className="border-b border-[#1062D0]">{date.year}</span>
                <span className="text-[#C2D0E3]">/</span>
                <span className="text-[#95A3B5]">( {date.month.name} )</span>
                <span className="border-b border-[#1062D0]">{date.month.number}</span>
                <span className="text-[#C2D0E3]">/</span>
                <span className="border-b border-[#1062D0]">{date.day}</span>
              </div>
            );
          }}
          styles={{ inputWrapper: { border: "none" } }}
          withoutClear
        />
      </div>
    </div>
  );
}
